import { html, type Html, View } from 'rune-ts';
import klass from './MotionSection.module.scss';
import { getResizedUrl } from '../../../../../shared/util/image';
import { HandmadeLandingMainMessage } from '../../icons';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger.js';
import { PauseScrollSmootherEvent, SetScrollIndexEvent } from '../../HandmadeCreatorLandingPage';

export class MotionSection extends View {
  constructor() {
    super({});
  }

  override template(): Html {
    return html`
      <section class="${klass.motion}">
        <div class="${klass.scroll}">
          <img
            class="${klass.main_image}"
            src="${getResizedUrl({
              url: '//s3.marpple.co/files/u_4648126/2025/1/original/209ce874058c9d41b60e6d592ba9b183f95a04341.webp',
              width: 14000 * 2,
              format: 'webp',
              quality: 85,
            })}"
            alt="메인 이미지"
          />
        </div>
        <div class="${klass.motion_slogan}">${HandmadeLandingMainMessage}</div>
      </section>
    `;
  }

  override onRender() {
    gsap.registerPlugin(ScrollTrigger);
    this.loadAutoHorizontalAnimation();
    this.loadScrollTrigger();
  }

  loadScrollTrigger() {
    ScrollTrigger.create({
      trigger: `.${klass.motion}`,
      start: 'top top',
      onLeave: () => {
        this.dispatchEvent(PauseScrollSmootherEvent, {
          bubbles: true,
          detail: { is_paused: true },
        });
      },
      onEnterBack: () => {
        this.dispatchEvent(SetScrollIndexEvent, { bubbles: true, detail: { current_index: 0 } });
      },
    });
  }

  loadAutoHorizontalAnimation() {
    const auto_scroll_tl = gsap.timeline();
    auto_scroll_tl.to(`.${klass.main_image}`, {
      x() {
        return -(this.targets()[0].offsetWidth - innerWidth);
      },
      duration: 180,
      timeScale: 1,
      repeat: -1,
      yoyo: true,
      ease: 'inOut',
    });
  }
}
